export default [
  {
    path: '/sfda-sources',
    name: 'sfda-sources',
    component: () => import('@/views/sfda-sources/SFDASources.vue'),
    meta: {
      title: 'SFDA Sources',
      requiresAuth: true,
      action: 'browes',
      resource: 'SFDA Sources',
      pageTitle: 'SFDA Sources',
      breadcrumb: [
        {
          text: 'SFDA Sources',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sfda-sources/add',
    name: 'add-sfda-sources',
    component: () => import(
      '@/views/sfda-sources/control-sfda-sources/AddEditSFDASources.vue'
    ),
    meta: {
      title: 'Add SFDA Sources ',
      requiresAuth: true,
      action: 'create',
      resource: 'SFDA Sources',
      pageTitle: 'SFDA Sources',
      breadcrumb: [
        {
          text: 'SFDA Sources',
          to: '/source-account',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sfda-sources/edit/:id',
    name: 'edit-sfda-sources',
    component: () => import(
      '@/views/sfda-sources/control-sfda-sources/AddEditSFDASources.vue'
    ),
    meta: {
      title: 'Edit SFDA Sources',
      requiresAuth: true,
      pageTitle: 'SFDA Sources',
      breadcrumb: [
        {
          text: 'SFDA Sources',
          to: '/sfda-sources',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
